import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { NotificationService } from '../projects/services/notification.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-notification-screen',
  templateUrl: './notification-screen.component.html',
  styleUrls: ['./notification-screen.component.scss'],
})
export class NotificationScreenComponent implements OnInit {
  notifications: any[] = [];
  pageSize = 16;
  page = 1;
  notificationId: number | null = null;
  selectedNotification: any | null = null;
  tabIndex: number = 0;
  search: string = '';

  loading: boolean = false;

  constructor(private notificationsService: NotificationService,
    private utilSrv: UtilsService,
    private route: ActivatedRoute,
    private translateService: TranslateService,) {
   // this.filter = _.debounce(this.filter, 500)
    this.notificationId = Number(this.route.snapshot.params.notificationId);
  }

  ngOnInit(): void {
    /* this.loadNotifications(); */
  }

  loadNotifications() {
    this.loading = true;
    this.notificationsService.getNotificationsForPage(this.pageSize, this.page, this.search)
      .pipe(first())
      .subscribe((response) => {
        this.notifications = [];
        this.notifications = response.data;
        if (this.notificationId) {
          let notification = response.data.find((d: any) => d.id == this.notificationId);
          if (!notification) {
            this.notificationsService.getNotification(this.notificationId).pipe(first()).subscribe(res => {
              this.selectedNotification = res.data[0];
              this.notifications.push(res.data[0]);
              this.loading = false;
            });
          } else {
            this.selectedNotification = notification;
            this.loading = false;
          }
        } this.loading = false;
      }, error => {
        console.error('All Notification', error);
        this.loading = false;
      });
  }

  loadNotificationsNotRead() {
    this.loading = true;
    this.notificationsService.getNotificationsForPageNotRead(this.pageSize, this.page, this.search)
      .pipe(first()).subscribe((response) => {
        this.notifications = [];
        this.notifications = response.data;
        this.loading = false;
      }, error => {
        console.error('Not Read', error);
        this.loading = false;
      });
  }

  clickButton(index: number) {
    /* if (index == 0) {
      this.page = 1;
      this.tabIndex = 0;
      this.selectedNotification = null;
      this.loadNotifications();

    } else if (index == 1) {
      this.page = 1;
      this.selectedNotification = null;
      this.tabIndex = 1;
      this.loadNotificationsNotRead();
    } */
  }

  select(item: any) {
    if (item.read == false) {
      this.notificationsService.updateNotification(item.id).pipe(first()).subscribe((response) => {
        this.notifications.find((value: { id: number; }) => value.id === item.id).read = true;
        this.notificationsService.realoadNotifications.next(true);
      }, error => {
        this.utilSrv.toast(`${this.translateService.instant('NOTIFICATIONS.UPDATEERROR')}: ${error}`, 'error', false);
      });
    }
    this.selectedNotification = item;

  }

  loadMore() {
    /* this.page += 1;

    if (this.tabIndex == 1) {
      this.notificationsService.getNotificationsForPageNotRead(this.pageSize, this.page, this.search).pipe(first()).subscribe((response) => {
        let ids = this.notifications.map((o: { id: number; }) => o.id)
        let resChecked = response.data.filter((o: { id: number; }) => !ids.includes(o.id))
        resChecked.sort((a: any, b: any) => {
          return a.id - b.id;
        });
        for (let x in resChecked) {
          this.notifications.push(resChecked[x]);
        }
      })
    } else if (this.tabIndex == 0) {
      this.notificationsService.getNotificationsForPage(this.pageSize, this.page, this.search).pipe(first()).subscribe((response) => {
        let ids = this.notifications.map((o: { id: number; }) => o.id)
        let resChecked = response.data.filter((o: { id: number; }) => !ids.includes(o.id))
        resChecked.sort((a: any, b: any) => {
          return a.id - b.id;
        });

        for (let x in resChecked) {
          this.notifications.push(resChecked[x]);
        }
      })
    } */
  }

  filter() {
    /* this.page = 1
    if (this.tabIndex == 0) {
      this.loadNotifications();
    } else {
      this.loadNotificationsNotRead();

    } */
  }

}


